import styles from './AboutHero.module.css';

export default function AboutHero() {
  return (
    <section className={styles.hero}>
      <div className={styles.inner}>
        <span className={styles.eyebrow}>About us</span>
        <h1 className={styles.headline}>
          We don't just give you tools. We give you a team that actually talks to each other.
        </h1>
        <p className={styles.sub}>
          RepBuddy was built out of pure personal frustration, by reps who were tired of
          choosing between list quality and speed.
        </p>
      </div>
    </section>
  );
}
